export default __webpack_public_path__ + "static/media/fauna-fql-quote.0d973031.png";